export const getTrendingItems = (state) => state.lists.trendingList.items;
